import type { ReactElement } from 'react';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { FontWeight } from '@/theme/typography';
import { TREEMAP_LABEL_TEXT_STYLE, TREEMAP_LABEL_WRAPPER_STYLE, TREEMAP_VALUE_BASE_STYLE, type TreemapSectionCellModel, } from './treemap-cell-node-model';
import { NODE_TEXT } from './treemap-constants';
interface TreemapSectionCellProps {
    model: TreemapSectionCellModel;
}
export function TreemapSectionCell({ model, }: TreemapSectionCellProps): ReactElement {
    return (
    <div data-el="Cmarkdowntreemap/TreemapSectionCell/Root" style={model.rootStyle}>
      <div style={model.headerStyle}>
        {model.showLabel ? (<CmarkdownLabelText dataElScope="Cmarkdowntreemap/TreemapSectionCell" content={model.label} size={12} weight={FontWeight.SemiBold} style={TREEMAP_LABEL_WRAPPER_STYLE} paragraphStyle={{ marginBottom: 0, minWidth: 0 }} textStyle={{ ...TREEMAP_LABEL_TEXT_STYLE, color: model.labelColor }}/>) : (<span/>)}
        {model.showLabel ? (<span style={{ ...TREEMAP_VALUE_BASE_STYLE, color: NODE_TEXT }}>
            {model.formattedValue}
          </span>) : null}
      </div>
    </div>
    );
}
